// extracted by mini-css-extract-plugin
module.exports = {"panel":"styles_panel__3z_6I","title":"styles_title__ctJQQ","right":"styles_right__1bZ1x"};